import { AxiosInstance } from "axios";

export interface PredictionValue {
  nom: string;
  month: string;
  moyenne: number;
}

export const predictionService = {
  /**
   * Get predictions by average method
   * Endpoint: GET /prediction/by-average
   */
  getPredictionsByAverage: async (
    api: AxiosInstance,
    idIndicateur: number,
    targetMonth: string, // format: "yyyy-MM"
    idIle?: number,
    idRegion?: number,
    idCommune?: number,
    idLocalite?: number
  ): Promise<PredictionValue[]> => {
    try {
      const params = new URLSearchParams({
        idIndicateur: String(idIndicateur),
        targetMonth: targetMonth,
      });

      if (idIle) params.append("idIle", String(idIle));
      if (idRegion) params.append("idRegion", String(idRegion));
      if (idCommune) params.append("idCommune", String(idCommune));
      if (idLocalite) params.append("idLocalite", String(idLocalite));

      const response = await api.get(`/prediction/by-average?${params.toString()}`);
      return response.data as PredictionValue[];
    } catch (error: any) {
      console.error("Erreur lors de la récupération des prédictions (moyenne) :", error);
      return [];
    }
  },

  /**
   * Get predictions by linear regression method
   * Endpoint: GET /prediction/by-regression
   */
  getPredictionsByRegression: async (
    api: AxiosInstance,
    idIndicateur: number,
    targetMonth: string, // format: "yyyy-MM"
    idIle?: number,
    idRegion?: number,
    idCommune?: number,
    idLocalite?: number
  ): Promise<PredictionValue[]> => {
    try {
      const params = new URLSearchParams({
        idIndicateur: String(idIndicateur),
        targetMonth: targetMonth,
      });

      if (idIle) params.append("idIle", String(idIle));
      if (idRegion) params.append("idRegion", String(idRegion));
      if (idCommune) params.append("idCommune", String(idCommune));
      if (idLocalite) params.append("idLocalite", String(idLocalite));

      const response = await api.get(`/prediction/by-regression?${params.toString()}`);
      return response.data as PredictionValue[];
    } catch (error: any) {
      console.error("Erreur lors de la récupération des prédictions (régression) :", error);
      return [];
    }
  },
};
